import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {CancelRsvpButtonProps} from './interfaces'

export const CancelRsvpButton = ({event}: CancelRsvpButtonProps) => {
  const {t} = useTranslation()
  const mobile = useMembersPageSelector(isMobile)
  const {experiments} = useExperiments()

  const {cancelRsvpOld, openCancelRsvpModal} = useMembersPageActions()

  return (
    <EventLink
      secondary={true}
      mobile={mobile}
      onClick={() =>
        experiments.enabled(ExperimentNames.UseEventsViewerReduxToolkit)
          ? openCancelRsvpModal({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_CANCEL_RSVP)})
          : cancelRsvpOld({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_CANCEL_RSVP)})
      }
      data-hook={DH.BUTTON_CANCEL_RSVP}
    >
      {t('events.buttons.update-rsvp')}
    </EventLink>
  )
}
